import styles from '../InformationsForms/InformationFormsStyle.module.scss'
import { Col, Form, Input, Row } from "antd"

const AddressField = ({ onChange, formValues, disabled, isForm = true, errors, employerInfo, prefix = '' }) => {
    const city = errors?.[`${prefix}city`]
    const state = errors?.[`${prefix}state`]
    const zip = errors?.[`${prefix}zip`]

    const cityValue = formValues?.[`${prefix}city`]
    const stateValue = formValues?.[`${prefix}state`]
    const zipValue = formValues?.[`${prefix}zip`]
    return (
        <div className={styles.formContainer}>
            <Row gutter={16} className={styles.gridContainer}>
                <Col xs={24} lg={12}>
                    {
                        isForm ? (
                            <>
                                <Form.Item layout="vertical" label="City" required validateStatus={city ? 'error' : ''}
                                    help={city}>
                                <Input size="large" fullWidth placeholder="City" id="city" name={`${prefix}city`} disabled={disabled} onChange={onChange} value={cityValue || ""} />
                                </Form.Item>
                            </>
                        ) : (
                            <div className="showFormField"><span><b>City:</b> {employerInfo?.[`${prefix}city`] || ""}</span></div>
                        )
                    }
                </Col>
                <Col xs={24} lg={6}>
                    {
                        isForm ? (
                            <>
                                <Form.Item layout="vertical" label="State" required validateStatus={state ? 'error' : ''}
                                    help={state}>
                                <Input size="large" fullWidth placeholder='State' id="state" name={`${prefix}state`} disabled={disabled} onChange={onChange} value={stateValue || ""} />
                                </Form.Item>
                            </>
                        ) : (
                            <div className="showFormField"><span><b>State:</b> {employerInfo?.[`${prefix}state`] || ""}</span></div>
                        )
                    }
                </Col>
                <Col xs={24} lg={6}>
                    {
                        isForm ? (
                            <>
                                <Form.Item layout="vertical" label="ZIP" required validateStatus={zip ? 'error' : ''}
                                    help={zip}>
                                <Input size="large" fullWidth placeholder='ZIP' id="zip" name={`${prefix}zip`} disabled={disabled} onChange={onChange} value={zipValue || ""} />
                                </Form.Item>
                            </>
                        ) : (
                            <div className="showFormField"><span><b>ZIP:</b> {employerInfo?.[`${prefix}zip`] || ""}</span></div>
                        )
                    }
                </Col>
            </Row>
        </div>
    )
}
export default AddressField